<template>
    <b-button class="change-button" @click="showModal = true">
        {{ $t('label.notifySettings') }}
        <b-modal v-model="showModal" class="justify-content-center align-items-center notify-settings-modal-window" centered :title="$t('label.notifySettings')">
            <div v-if="isTeacher" class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.newSolution') }}
                </div>

                <b-form-checkbox v-model="notifications.newSolution" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div v-if="!isTeacher" class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.newComment') }}
                </div>

                <b-form-checkbox v-model="notifications.newComment" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div v-if="isTeacher" class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.newQuestion') }}
                </div>

                <b-form-checkbox v-model="notifications.newQuestion" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.contestNotifyStarted') }}
                </div>

                <b-form-checkbox v-model="notifications.contestNotifyStarted" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.contestNotifyStart') }}
                </div>

                <b-form-checkbox v-model="notifications.contestNotifyStart" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.contestNotifyEnd') }}
                </div>

                <b-form-checkbox v-model="notifications.contestNotifyEnd" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.groupStats') }}
                </div>

                <b-form-checkbox v-model="notifications.groupStats" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ isTeacher ? $t('notificationType.groupCourse') : $t('notificationType.groupCourseStudent') }}
                </div>

                <b-form-checkbox v-model="notifications.groupMailing" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>

            <div v-if="isTeacher" class="notify-settings-modal justify-content-center d-flex">
                <div class="font-weight-light mb-2">
                    {{ $t('notificationType.groupEntryLeave') }}
                </div>

                <b-form-checkbox v-model="notifications.groupJoinLeave" class="notify-settings-checkbox" switch @change="handleNotificationSettings" />
            </div>
        </b-modal>
    </b-button>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { USER_UPDATE_NOTIFY_SETTINGS } from 'actions/user';

    export default {
        name: 'NotifySettings',

        computed: {
            ...mapGetters('user', [ 'profile', 'status' ]),

            isTeacher() {
                let permissions = this.profile.permissions;
                let TEACHER = this.$defines.SERVICE_ACCOUNT_TYPES.TEACHER;
                return permissions.mirera === TEACHER || permissions.pm === TEACHER;
            }
        },

        data() {
            return {
                notifications: {
                    groupStats: true,
                    groupMailing: true,
                    newComment: true,
                    newQuestion: true,
                    newSolution: true,
                    groupJoinLeave: true,
                    contestNotifyStarted: true,
                    contestNotifyStart: true,
                    contestNotifyEnd: true
                },
                mapping: {
                    groupStats: this.$defines.NOTIFICATION_TYPES.GROUP_STATS,
                    groupMailing: this.$defines.NOTIFICATION_TYPES.MESSAGE_FROM_SENDER,
                    newComment: this.$defines.NOTIFICATION_TYPES.COMMENT_UPDATED,
                    newQuestion: this.$defines.NOTIFICATION_TYPES.QUESTION_UPDATED,
                    newSolution: this.$defines.NOTIFICATION_TYPES.TEST_SOLUTION,
                    groupJoinLeave: this.$defines.NOTIFICATION_TYPES.GROUP_MEMBERSHIP,
                    contestNotifyStarted: this.$defines.NOTIFICATION_TYPES.CONTEST_STARTED,
                    contestNotifyStart: this.$defines.NOTIFICATION_TYPES.CONTEST_WILL_START,
                    contestNotifyEnd: this.$defines.NOTIFICATION_TYPES.CONTEST_WILL_END
                },

                showModal: false
            };
        },

        watch: {
            status() {
                this.fetchDisabledTypes();
            }
        },

        created() {
            this.fetchDisabledTypes();
        },

        methods: {
            fetchDisabledTypes() {
                for (const [ key, value ] of Object.entries(this.mapping))
                    this.notifications[key] = !this.profile.disabledNotificationTypes[value];

            },

            async handleNotificationSettings() {
                let neededTypes = {};

                for (const [ key, value ] of Object.entries(this.mapping)) {
                    if (!this.notifications[key]) {
                        neededTypes[value] = 1;

                        if (value === this.$defines.NOTIFICATION_TYPES.GROUP_MEMBERSHIP)
                            neededTypes[this.$defines.NOTIFICATION_TYPES.APPLICATION_TO_GROUP] = 1;
                    }
                }

                await this.$store.dispatch(`user/${USER_UPDATE_NOTIFY_SETTINGS}`, neededTypes);
            }
        }
    };
</script>

<style scoped>
    .notify-settings-checkbox ::before {
        background: none;
    }

    .notify-settings-checkbox ::before :checked {
        background: white !important;
    }

    .notify-settings-checkbox {
        margin-left: auto;
    }

    .notify-settings-modal-last ::before {
        background: none;
    }

    .notify-settings-modal-last ::before :checked {
        background: white !important;
    }

    .notify-settings-modal-window {
        max-width: 450px !important;
    }

    /deep/ .custom-control-input:checked ~ .custom-control-label::before {
        background-color: rgb(51, 141, 201) !important;
        border-color: rgb(51, 141, 201) !important;
    }

    /deep/ .modal-footer {
        display: none !important;
    }
</style>